import Sparkline from './Sparkline';
import { compactNumber } from './format';

type Props = {
  label: string;
  value: number | string;
  /** Fraction change vs the previous period. Omit when there is nothing to
   *  compare against. */
  delta?: number;
  points?: number[];
  footnote?: string;
};

export default function StatTile({ label, value, delta, points, footnote }: Props) {
  const shown = typeof value === 'number' ? compactNumber(value) : value;
  // Real minus sign, not a hyphen — it aligns with the digits.
  const deltaText =
    delta === undefined
      ? null
      : `${delta >= 0 ? '+' : '−'}${Math.abs(delta * 100).toFixed(1)}%`;

  return (
    <article className="rounded-2xl bg-white p-5 shadow-card">
      <p className="font-nunito text-sm text-ink-soft">{label}</p>

      <div className="mt-2 flex items-end justify-between gap-3">
        {/* Proportional figures: tabular-nums gives every digit a zero's width,
            which reads loose at this size. Tabular is for table columns. */}
        <span className="font-nunito text-3xl font-semibold text-ink">{shown}</span>
        {points && points.length > 1 && <Sparkline points={points} />}
      </div>

      {deltaText && (
        <p className="mt-2 font-nunito text-xs text-ink-soft">
          {deltaText} vs previous period
        </p>
      )}

      {footnote && <p className="mt-2 font-nunito text-xs text-meta">{footnote}</p>}
    </article>
  );
}
